import React, { useState } from 'react'
import Logo from '../assets/logo2.png'
import visaIcon from '../assets/visa.png';
import mastercardIcon from '../assets/mastercard.png';
import mobiboxLogo from '../assets/mobiboxlogo.png';
import Headset from '../assets/headset.svg'


export default function Footer() {

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Name: '',
        LastName: '',
        Email: '',
        Message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await fetch('https://x95nw9pp7b.execute-api.eu-central-1.amazonaws.com/live/service-email-sender', {
                mode: 'no-cors',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    ServiceID: '8',
                }),
            });

            alert('Message sent successfully!');
            setFormData({ Name: '', LastName: '', Email: '', Message: '' });
        } catch (error) {
            console.error('Error sending message:', error);
            alert('Something went wrong. Please try again later.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <div>


            <section data-aos="zoom-in" className="container my-5 py-5" style={{position:'relative'}}>
                <img src={Headset} className='controller1' />
                <h2 className="text-center mt-4">Contact Us</h2>
                <p className='text-center' >Our team is always ready to help - get in touch today !</p>

                <form onSubmit={handleSubmit} className="row g-3 mt-4" style={{ boxShadow: '#00000059 1px 1px 7px', borderRadius: '15px', padding: '1rem' }}>
                    <div className="col-md-6">
                        <input
                            placeholder='Enter your first name'
                            type="text"
                            className="form-control"
                            id="Name"
                            name="Name"
                            value={formData.Name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <input
                            placeholder='Enter your last name'
                            type="text"
                            className="form-control"
                            id="LastName"
                            name="LastName"
                            value={formData.LastName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-12">
                        <input
                            type="email"
                            placeholder='Enter your email'
                            className="form-control"
                            id="Email"
                            name="Email"
                            value={formData.Email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-12">
                        <textarea
                            className="form-control"
                            placeholder='Enter your message'
                            id="Message"
                            name="Message"
                            rows="5"
                            value={formData.Message}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="d-flex flex-row align-items-center w-100 justify-content-center">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ float: 'right', minWidth: '120px' }}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                </>
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </div>
                </form>

            </section>



            <footer className="text-white py-5" style={{ borderTop: '1px solid #ffffff45' }}>
                <div className="container">
                    <div className="row  text-md-start">

                        {/* Column 1: Logo + Payment */}
                        <div className="col-md-6 mb-4">
                            <img src={Logo} alt="Gaming Pro Premium Logo" width={60} className="mb-3" />
                            <p className="mb-2">© 2024 | All Rights Reserved</p>
                            <div className="d-flex justify-content-md-start gap-1">
                                <img src={visaIcon} alt="Visa" style={{ height: '35px' }} />
                                <img src={mastercardIcon} alt="MasterCard" style={{ height: '35px' }} />
                            </div>
                        </div>

                        {/* Column 2: Navigation */}
                        {/* <div className="col-md-4 mb-4">
                            <span className='fs-5 fw-bold'>Quick Links</span>
                            <ul className="list-unstyled">
                                <li><a href="/" className="text-white text-decoration-none">Home</a></li>
                                <li><a href="/games" className="text-white text-decoration-none">Games</a></li>
                            </ul>
                        </div> */}

                        {/* Column 3: Subscribe */}
                        {/* <div className="col-md-6 mb-4">
                            <span className='fs-5 fw-bold'>Subscribe</span>
                            <p className="small text-light">Stay updated with our latest games & offers.</p>
                            <div className="input-group">
                                <a className="btn btn-primary" href='https://publisherads.click/?SMCampaign=4b76ea47-f7f4-4557-8548-181e76406142&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=null&themeid=3&portal=GamesBox'
                                    target='_blank'>Subscribe Now</a>
                            </div>
                        </div> */}

                           <div className="col-md-6 mb-4">
                            <p className="text-light small mb-1">Powered By</p>
                        <img src={mobiboxLogo} alt="MobiBox Logo" style={{ width: '140px' }} className="mb-2" />
                        <p className="text-light small">
                            Mobi Box GmbH, Kemperplatz 1, Sony Center, 10785 Berlin, DE
                        </p>
                        </div>

                    </div>

                    {/* Powered By */}
                    {/* <div className="text-center mt-2">
                        <p className="text-light small mb-1">Powered By</p>
                        <img src={mobiboxLogo} alt="MobiBox Logo" style={{ width: '140px' }} className="mb-2" />
                        <p className="text-light small">
                            Mobi Box GmbH, Kemperplatz 1, Sony Center, 10785 Berlin, DE
                        </p>
                    </div> */}
                </div>
            </footer>

        </div>
    )
}
